import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export const UseOnRouteChange = (callback) => {
  const {pathname} = useLocation()

  useEffect(() => {
    callback()

  }, [pathname])
    
    
}